export const httpStatusEnum = {
  SUCCESS: 200,
  UNDEFINED: 0,
  UNAUTHORIZED: 401,
  INTERNAL_SERVER_ERROR: 500,
  ANY_OTHER_EXCEPTION: 600,
  NOT_AUTHORIZED: 601,
  NOT_FOUND_DAO: 602,
  IMAGE_UPLOAD_EXCEPTION: 603,
  DOWNLOAD_EXCEPTION: 604,
  NOT_VALID_ACTION_EXCEPTION: 605,
  BAD_REQUEST: 606
};

export const AppStatusEnum = {
  ACTIVE: 'Active',
  INACTIVE: 'Inctive'
};

export const APPSTRINGS = {
  ROSTERNAME: 'NCICIRB'
};

export const ATCONSTANTS = {
  APP: '_REGULATORY',
  PACKETID: 'PACKET_',
  RDIMSID: 'RDIMS_',
  CAPID: 'CAP_',
  SRBID: 'SRB_',
  IRBID: 'IRB_',
  LPOID: 'LPO_',
  ID: 'ID_',
  SRID: 'SR_',
  BUTTON: '_BUTTON',
  DIV: '_DIV',
  TABLE: '_TABLE',
  INPUT: '_INPUT',
  SELECT: '_SIMPLE_SELECT',
  CALENDAR: '_CALENDAR',
  LABEL: '_LABEL',
  MULTI: '_MULTI',
  QUEUE: '_QUEUE',
  LINK: '_LINK',
  SUBSTUDY: '_SUB_STUDY',
  TAB: '_TAB',
  CELL: '_CELL',
  TEXTAREA: '_TEXT_AREA',
  FORMROW: '_FORM_ROW'
};


export const communicateOptions = [
  {
    rLabel: 'Email',
    value: 'Email',
    name: 'email',
    id: 'email'
  },
  {
    rLabel: 'Phone',
    value: 'Phone',
    name: 'phone',
    id: 'phone'
  },
  {
    rLabel: 'None',
    value: 'None',
    name: 'none',
    id: 'none'
  }
];
export const crOptions = [
  {
    rLabel: null,
    value: 'Yes',
    name: 'yes',
    id: 'yes'
  }
];

export const allowedFileTypes = {
  'image/png': ['.png'],
  'image/tiff': ['.tiff', '.tif'],
  'application/pdf': ['.pdf'],
  'text/plain': ['.txt'],
  'text/html': ['.html', '.htm'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
  'application/vnd.ms-outlook': ['.msg']
};
